<template>
  <div id="app">
    <v-app id="inspire">
      <v-container>
        <v-layout class="justify-center">
          <v-flex xs12 sm6 md6 lg4 xl3>
            <v-card elevation="2" light tag="section" class="">
              <v-card-title style="margin-bottom: -25px">
                <v-layout column align-center>
                  <h3 class="title" style="font-size: 22px !important">
                    {{ platformName }}
                  </h3>
                  <br />
                  <div class="" style="font-size: 16px !important; text-align: center">
                    - Fully privacy preserving implementation
                    <p>- No personal data leaves user device</p>
                  </div>
                </v-layout>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="ma-3">
                <p>Sign in with your username and password:</p>
                <v-form>
                  <v-text-field
                    style="width: 300px"
                    label="User name"
                    readonly
                    type="text"
                    value="someone@example.com"
                  ></v-text-field>
                  <v-text-field
                    style="width: 300px"
                    label="Password"
                    readonly
                    type="password"
                    value="●●●●●●"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions style="margin-top: -35px">
                <v-container grid-list-xl>
                  <v-layout column>
                    <v-flex>
                      <span class="title">Please verify you are a human by reading a sentence we have for you:</span>
                    </v-flex>
                    <v-flex>
                      <iframe
                        id="voiceCaptcha"
                        src="https://new-voice-captcha-module.s3.eu-west-1.amazonaws.com/index.html?session_id=67ed4d7a-41c6-4a46-aafb-b58ccc2c29e4&session_password=6iiYEnPDt.mqE-FIAh6HPIsoA0vB2_"
                        width="300"
                        height="140"
                        scrolling="no"
                        allow="microphone"
                        frameborder="0"
                      ></iframe>
                    </v-flex>
                    <v-flex
                      ><v-btn :disabled="!isVerificationSuccessful" color="info" :large="$vuetify.breakpoint.smAndUp">
                        <v-icon left>lock</v-icon>
                        Login
                      </v-btn></v-flex
                    >
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-app>
  </div>
</template>


<script>
export default {
  mounted() {
    window.addEventListener("message", this.receiveMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMessage);
  },
  methods: {
    receiveMessage(event) {
      if (event.data == "success") {
        this.isVerificationSuccessful = true;
      }
    },
  },
  data() {
    return {
      darkTheme: true,
      isVerificationSuccessful: false,
      platformName: "On-Browser Voice Captcha Demo",
      password: null,
      username: null,
    };
  },
};
</script>



